<template>
  <section>
    <navbar-public></navbar-public>
    <section class="ew-smaller-container ew-mb">
      <div class="ew-card">
        <h1 class="ew-section-header ew-section-header--no-margin">¡Hola, soy Envi! Bienvenido a Moovet</h1>
        <p class="ew-about-font-top">Somos una empresa de envíos online que ofrece servicios integrales de paquetería y logística, <strong>comprometidos principalmente con las PYMES y el desarrollo del e-commerce.</strong></p>

        <div class="ew-about-row">
          <div class="ew-about-row__text">
            <p>La idea nace derivado del crecimiento exponencial en las ventas online, y lo difícil que se ha convertido para las Pymes y las e-commerce distribuir sus productos de manera ágil y a un costo que les permita crecer.</p>
            <p>Por ello, nos dimos a la tarea de desarrollar el concepto de "E-logística = logística del comercio electrónico" permitiendo a nuestros usuarios el uso de diversos menús logísticos con las paqueterías más grandes del país, además, por medio de la tecnología implementada en nuestra plataforma podrán agilizar, administrar y realizar sus envíos de manera automatizada.</p>
          </div>
          <img src="@/assets/images/enviabout.png" alt="" class="ew-envi-about">
        </div>

        <p class="ew-about-font-footer">¿Estás pensando en desarrollar tu e-commerce?<br>o ¿Lo tienes desarrollado y necesitas ayuda con la logística?</p>

        <router-link class="ew-btn-primary" to="/signup">Registrarme</router-link>
      </div>
    </section>

    <footer-public></footer-public>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import NavbarPublic from './Header/NavbarPublic'
import FooterPublic from './Header/FooterPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'AboutUs',
  data () {
    return {}
  },
  watch: {},
  methods: {},
  computed: {},
  created () {},
  components: {
    'navbar-public': NavbarPublic,
    'footer-public': FooterPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 760px; margin: 0 auto; }
.ew-mb { margin-bottom: 5rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }

.ew-about-font-top {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--app-navy-secondary);
  font-family: var(--app-font);
}

.ew-about-row {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin: 1.5rem 0;
  flex-wrap: wrap;

  &__text {
    flex: 1 1 320px;
    font-family: var(--app-font);
    color: var(--app-navy-secondary);
    line-height: 1.6;
  }
}

.ew-envi-about {
  width: 15rem;
  flex-shrink: 0;
}

.ew-about-font-footer {
  font-family: var(--app-font);
  font-size: 1.15rem;
  line-height: 1.5;
  color: var(--app-accent);
  font-weight: 600;
  margin-bottom: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue